import { BadgeCheck, MessageCircle, Sparkles, Stethoscope, Truck } from "lucide-react";

const trustItems = [
  { icon: Stethoscope, label: "Clinician reviewed" },
  { icon: Sparkles, label: "Transparent pricing" },
  { icon: Truck, label: "Free expedited shipping" },
  { icon: MessageCircle, label: "24/7 provider messaging" },
  { icon: BadgeCheck, label: "Available in all 50 states" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="bg-[#F3F1EC]/60 border-y border-[#E8E5DF]">
      <div className="max-w-3xl md:max-w-4xl mx-auto overflow-hidden">
        <div className="py-2 trust-marquee-mask">
          <div className="trust-marquee" data-testid="trust-marquee">
            {[...trustItems, ...trustItems].map(({ icon: Icon, label }, idx) => (
              <div
                key={`${label}-${idx}`}
                aria-hidden={idx >= trustItems.length ? "true" : undefined}
                className="flex items-center gap-6 md:gap-8 text-[13px] md:text-sm text-[#5E5C58] pr-6 md:pr-8 shrink-0"
              >
                <div className="flex items-center gap-2">
                  <Icon size={14} className="text-[#8A9A92] shrink-0 md:hidden" />
                  <Icon size={16} className="text-[#8A9A92] shrink-0 hidden md:inline" />
                  <span className="font-medium whitespace-nowrap">{label}</span>
                </div>
                <span
                  aria-hidden="true"
                  className="w-1.5 h-1.5 rounded-full bg-[#E8B5A1] shrink-0"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
